import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import Pencil from 'Assets/images/pencil.svg'

import { StepContext } from '../../contexts'
import MessageEdit from './edit/MessageEdit'
import StepLine from './StepLine'
import Draggable from './Draggable'
import linkifyHtml from 'linkify-html'
import { domPurifyKeepSpecificTagsAndContent } from 'Utils/dom-purify'

const Message = (props) => {
  const { actionId, index } = props

  const { step } = useContext(StepContext)

  const [editMode, setEditMode] = useState(false)

  const settings = _.get(step, 'settings', {})
  const action = _.get(settings, `${actionId}`)

  const onEditClick = () => setEditMode(true)
  const onCancelClick = () => setEditMode(false)

  function createMarkup(text) {
    // followed the approach similar to what is in Widget
    const linkifyOptions = {
      target: (_, type) => type === 'url' && '_blank'
    }
    const sanitisedText = domPurifyKeepSpecificTagsAndContent(text)
    const linkifiedText = linkifyHtml(sanitisedText, linkifyOptions)

    return { __html: linkifiedText }
  }

  return (
    <StepLine>
      <Draggable drag={!editMode} id={actionId} index={index}>
        <div className={classNames('quote-wrapper', { 'edit-mode': editMode })}>
          <div className='quote-item'>
            {editMode && <MessageEdit mode='edit' text={action.text} actionId={actionId} cancelFn={onCancelClick} />}
            {!editMode && (
              <React.Fragment>
                <div className='quote' dangerouslySetInnerHTML={createMarkup(action.text)} />
                <div className='action-icon edit' onClick={onEditClick} title='edit'>
                  <Pencil height='16' width='16' />
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </Draggable>
    </StepLine>
  )
}

export default Message
